import { render, staticRenderFns } from "./password-details.vue?vue&type=template&id=1d31c9b5"
import script from "./password-details.vue?vue&type=script&lang=js"
export * from "./password-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports